import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import { Card } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import createSharedReactContext from 'create-shared-react-context';
import { VirtualPaymentGlobalContext } from '../utils/constants';

const GlobalContext = createSharedReactContext({}, VirtualPaymentGlobalContext);

const ErrorMessage = ({ errorId = 'pageNotFoundMessage' }) => {
  const errorMessage = useIntl().formatMessage({ id: errorId });
  const { setLogOutDisabled } = useContext(GlobalContext);
  setLogOutDisabled(true);

  return (
    <div className="row pad-responsive">
      <div className="col-lg-6 col-md-8 col-sm-10 col-xs-12 margin-auto">
        <Card>
          <div className="text-align-center pad-3-tb" role="alert">
            <div className="pad-responsive-lr stack">
              <span className="dls-color-warning icon dls-icon-warning icon-lg" />
              <h1 className="heading-4 margin-1-b">{errorMessage}</h1>
              <br />
            </div>
          </div>
        </Card>
      </div>
    </div>
  );
};

ErrorMessage.propTypes = {
  errorId: PropTypes.string,
};

export default ErrorMessage;
